/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, ReactNode, useState, useEffect, useCallback, useRef } from 'react';
import { styled } from 'linaria/react';
import EasySwipe from 'react-easy-swipe';
import { useIntervalCallback } from '@shared/lib';
import Dots from './Dots';
interface AutoScrollerProps {
  content: ReactNode[];
  autoInterval?: number;
}
const AutoScroller: FC<AutoScrollerProps> = ({
  content,
  autoInterval = 5000
}) => {
  const total = content.length;
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const didSwipeRef = useRef(false);
  useIntervalCallback(() => {
    if (!document.hidden) {
      goToNext();
    }
  }, isPaused || total <= 1 ? null : autoInterval);
  useEffect(() => {
    setActiveIndex(0);
  }, [total]);
  const normalizeIndex = (index: number): number => {
    if (total <= 1) return 0;
    return (index % total + total) % total;
  };
  const goToIndex = useCallback((nextIndex: number) => {
    const normalized = normalizeIndex(nextIndex);
    if (normalized === activeIndex) return;
    setActiveIndex(normalized);
  }, [activeIndex, total]);
  const goToNext = useCallback(() => goToIndex(activeIndex + 1), [goToIndex, activeIndex]);
  const goToPrev = useCallback(() => goToIndex(activeIndex - 1), [goToIndex, activeIndex]);
  const handleDotClick = (index: number) => {
    goToIndex(index);
  };
  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);
  const handleSwipeStart = () => {
    didSwipeRef.current = false;
    setIsPaused(true);
  };
  const handleSwipeMove = (position: {
    x: number;
    y: number;
  }) => {
    if (Math.abs(position.x) > Math.abs(position.y)) {
      if (Math.abs(position.x) > 10) {
        didSwipeRef.current = true;
      }
      return true;
    }
    return false;
  };
  const handleSwipeEnd = () => setIsPaused(false);
  const handleClickCapture = (event: React.MouseEvent) => {
    if (!didSwipeRef.current) return;
    event.preventDefault();
    event.stopPropagation();
    didSwipeRef.current = false;
  };
  if (total === 0) return null;
  return <AutoScrollerWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} aria-live="polite">
      <SwipeArea onClickCapture={handleClickCapture}>
        {/* @ts-ignore */}
        <EasySwipe allowMouseEvents tolerance={50} onSwipeLeft={goToNext} onSwipeRight={goToPrev} onSwipeMove={handleSwipeMove} onSwipeStart={handleSwipeStart} onSwipeEnd={handleSwipeEnd}>
          <ScrollerContainer className="scroller-container">
            <ContentTrack activeIndex={activeIndex}>
              {content.map((item, i) => <Slide key={`slide-${i}`} index={i}>
                  {item}
                </Slide>)}
            </ContentTrack>
          </ScrollerContainer>
        </EasySwipe>
      </SwipeArea>
      <Dots count={total} activeItemIndex={activeIndex} onDotClick={handleDotClick} />
    </AutoScrollerWrapper>;
};
export default AutoScroller;
const AutoScrollerWrapper = /*#__PURE__*/styled('div')({
  name: "AutoScrollerWrapper",
  class: "alqcevk",
  propsAsIs: false
});
const SwipeArea = /*#__PURE__*/styled('div')({
  name: "SwipeArea",
  class: "s1n4yv7z",
  propsAsIs: false
});
const ScrollerContainer = /*#__PURE__*/styled('div')({
  name: "ScrollerContainer",
  class: "s1958exs",
  propsAsIs: false
});
interface ContentTrackProps {
  activeIndex: number;
}
const _exp = /*#__PURE__*/() => ({
  activeIndex
}) => `translateX(-${activeIndex * 100}%)`;
const ContentTrack = /*#__PURE__*/styled('ul')({
  name: "ContentTrack",
  class: "c18tivm9",
  propsAsIs: false,
  vars: {
    "c18tivm9-0": [_exp()]
  }
});
interface SlideProps {
  index: number;
}
const Slide = /*#__PURE__*/styled('li')({
  name: "Slide",
  class: "s1nnb6oy",
  propsAsIs: false
});

require("./AutoScroller.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./AutoScroller.tsx");